import { TEMPLATE_CATEGORY_BDC } from '../constants/templates';

/**
 * Check if a category should be visible
 * For BDC category, checks permissions. For all other categories, always returns true.
 *
 * @param {string} categoryId - The category ID to check
 * @param {boolean} hasBDCReadPermission - Whether the user has BDC read permission
 * @returns {boolean} - True if the category should be visible
 */
export const isBDCCategoryVisible = (
    categoryId: string,
    hasBDCReadPermission: boolean
): boolean => {
    if (categoryId !== TEMPLATE_CATEGORY_BDC) {
        return true;
    }
    return hasBDCReadPermission;
};
